import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import InvoiceTable from '@accounting/components/tables/invoice-table/invoice-table.vue';

@Component({
  name: 'bpc-credit-note',
  components: {
    'bpc-invoice-table': InvoiceTable,
  },
})
export default class Tickets extends Vue {
  public filterConfigName = 'tickets-filters';
  public filtersExcluded = ['type'];
  public tableTitle = 'global.models.ticket.heading';
  public tableSubtitle = 'global.models.ticket.subheading';
  public extendedFilterConfigName = '';
  public displayConfigName = 'tickets-table';
  public formConfigName: string = 'create-ticket-form';
  public sendInvoiceAction: boolean = false;
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
